import styled from "styled-components";

import { colorsPalettes, rgba } from "@similarweb/styles";
import { Text, Flex } from "@similarweb/ui-components/foundations";

export const Container = styled(Flex)`
    justify-content: space-between;
    align-items: center;
`;

export const UserName = styled(Text)`
    color: ${rgba(colorsPalettes.carbon[500], 0.8)};
`;

export const ActionsContainer = styled(Flex)`
    align-items: center;
    gap: 16px;
`;
